export enum TimesheetColumnEnums {
  DELETE = 'delete',
  DEPARTMENT = 'department',
  JOBS = 'jobs',
  ABSENCES_OVERRIDES = 'absenceAndOverride',
  TOTAL_HOURS = 'totalDurationInSeconds',
  TOTAL_EXPENSES = 'totalExpenses',
}

export enum TimesheetTotalColumnEnums {
  TOTAL_ROW_NAME = 'total-row-name',
  GRAND_TOTAL_HOURS = 'grand-total-hours',
  GRAND_TOTAL_EXPENSES = 'grand-total-expenses',
}

export enum TimesheetTotalRowEnums {
  TOTAL_HOURS = 'total-row-hours',
  TOTAL_EXPENSES = 'total-row-expenses',
}

export enum TimesheetExtraColumnEnums {
  EXTRA_ROW_NAME = 'extra-row-name',
  GRAND_TOTAL_HOURS = 'grand-total-hours',
  GRAND_TOTAL_EXPENSES = 'grand-total-expenses',
}

export enum TimesheetExtraRowEnums {
  EXTRA_TIME = 'extra-time-row',
}
